import React from "react";

import KeyIcon from "@mui/icons-material/Key";

function Notifications() {
  return (
    <div className="container">
      <KeyIcon style={{ position: "absolute", left: "0" }} />
      <h2>Notifications</h2>
      <p>Here you can scroll through all your notifications.</p>
    </div>
  );
}

export default Notifications;
